import axios from './axiosInstances/axiosInstance';

export const sendGroupOrderInvites = (groupOrderId, emails) => {
  return axios.post(`/baskets/grouporders/${groupOrderId}/invites`, {
    emailaddresses: emails,
  });
};
